//用户store
import { loginByMobile, loginByPassWord, forgotPassword, register, getUserInfo } from '@/api/user';
const getDefaultState = () => {
    return {
        isLogin: false,
        userInfo: {}
    }
}
export default {
    namespaced: true,
    state: getDefaultState(),
    getters: {
        isLogin: state => state.isLogin,
        userInfo: state => state.userInfo,
    },
    mutations: {
        SET_IS_LOGIN: (state, isLogin) => {
            state.isLogin = isLogin
        },
        SET_USER_INFO: (state, userInfo) => {
            state.userInfo = userInfo
        },
        RESET_STATE: (state, payload) => {
            Object.assign(state, payload)
        }
    },
    actions: {
        login({ commit }, payload) {
            return new Promise((resolve, reject) => {
                loginByPassWord({ ...payload }).then(res => {
                    if (res.code == 200) {
                        commit('SET_IS_LOGIN', true)
                        resolve(res)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        quickLogin({ commit }, payload) {
            return new Promise((resolve, reject) => {
                console.log(payload)
                loginByMobile({ ...payload }).then(res => {
                    if (res.code == 200) {
                        commit('SET_IS_LOGIN', true)
                        resolve(res)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        register({ commit }, payload) {
            return new Promise((resolve, reject) => {
                console.log(payload)
                register({ ...payload }).then(res => {
                    if (res.code == 200) {
                        commit('SET_IS_LOGIN', true)
                        resolve(res)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        logout({ dispatch, commit }, payload) {
            dispatch('reset', {})
        },
        forgot({ dispatch, commit }, payload) {
            return new Promise((resolve, reject) => {
                console.log(payload)
                forgotPassword({ ...payload }).then(res => {
                    if (res.code == 200) {
                        dispatch('reset', {})
                        resolve(res)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        setUserInfo({ dispatch, commit }) {
            return new Promise((resolve, reject) => {
                getUserInfo().then(res => {
                    if (res.code == 200) {
                        commit('SET_IS_LOGIN', true)
                        commit('SET_USER_INFO', res.data)
                        resolve(res)
                    }
                }).catch(error => {
                    reject(error)
                })
            })
        },
        reset({ commit, state }) {
            commit('RESET_STATE', getDefaultState())
        }
    }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js